module.exports = __webpack_public_path__ + "bfd315078b9cffc8dcda88e3de058353.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/headers/ppu.jpg
 ** module id = 426
 ** module chunks = 0
 **/